export const features = [
  {
    icon: 'ri-shield-check-line',
    title: '军工级安全加密',
    description: '采用AES-256位加密标准和TLS 1.3传输协议，确保登录数据在传输和存储过程中的绝对安全。多层防火墙和实时入侵检测系统全天候守护。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '毫秒级极速登录',
    description: '基于分布式架构和智能路由技术，实现毫秒级的登录响应速度。全球CDN加速节点确保无论身处何地都能享受极速登录体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台无缝支持',
    description: '完美兼容Windows、macOS、iOS、Android等主流平台，支持网页端、移动端、桌面端多形态登录，一处注册全平台通用。',
  },
  {
    icon: 'ri-fingerprint-line',
    title: '生物识别登录',
    description: '支持指纹识别、面部识别、声纹识别等多种生物特征认证方式，让登录像解锁手机一样简单自然。',
  },
  {
    icon: 'ri-device-line',
    title: '多设备智能管理',
    description: '实时查看所有已登录设备，远程管理设备授权，一键踢出可疑会话。设备指纹技术精准识别每一台设备。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '7×24小时专属服务',
    description: '专业技术支持团队全天候待命，为企业客户提供专属客户经理、快速响应通道和定期安全报告等VIP服务。',
  },
];

export const stats = [
  { value: '5000万+', label: '累计用户数' },
  { value: '99.99%', label: '服务可用率' },
  { value: '200+', label: '合作企业' },
  { value: '30秒', label: '平均响应时间' },
];

export const testimonials = [
  {
    name: '张伟',
    role: '技术总监',
    company: '星辰科技有限公司',
    content: '自从接入开云登录后，我们公司的用户登录成功率提升了15%，账户安全事件下降了80%。开云登录的安全性和稳定性令人印象深刻。',
  },
  {
    name: '李娜',
    role: '产品经理',
    company: '云端互联科技',
    content: '开云登录的一键登录功能大大改善了用户体验。多平台无缝切换的设计让我们的用户满意度大幅提升，强烈推荐！',
  },
  {
    name: '王强',
    role: 'CTO',
    company: '数智未来集团',
    content: '作为企业级客户，开云登录的SSO单点登录方案解决了我们多年的多系统认证难题。权限管理精细、审计日志完整，完全满足合规要求。',
  },
];

export const faqs = [
  {
    question: '开云登录支持哪些登录方式？',
    answer: '开云登录支持账号密码登录、手机验证码登录、邮箱验证码登录、扫码登录、指纹/面部识别登录等多种方式。您可以根据使用场景和个人偏好选择最便捷的登录方式。',
  },
  {
    question: '如何保障我的账户安全？',
    answer: '开云登录提供多重安全保障：双因素认证（2FA）、异常登录实时检测、TLS 1.3加密传输、AES-256数据加密、设备指纹识别等。建议您开启双因素认证并定期更换密码以获得最佳安全体验。',
  },
  {
    question: '开云登录是否免费使用？',
    answer: '开云登录基础版对个人用户完全免费，提供核心登录功能和基础安全保障。企业版提供SSO单点登录、权限管理、审计日志等高级功能，具体收费请咨询我们的商务团队。',
  },
  {
    question: '可以在多少台设备上同时登录？',
    answer: '开云登录支持在多台设备上同时保持登录状态。您可以在账户设置中查看所有已登录设备，并对不需要的设备进行远程下线操作。企业版支持更灵活的会话管理策略。',
  },
  {
    question: '忘记密码如何找回？',
    answer: '您可以通过登录页面的"忘记密码"功能，使用绑定的手机号或邮箱接收验证码后重置密码。如果遇到任何问题，可随时拨打客服热线 400-888-0000 获取帮助。',
  },
  {
    question: '开云登录支持API集成吗？',
    answer: '是的，开云登录提供完善的API接口和SDK，支持OAuth 2.0、SAML 2.0等标准协议，可以方便地集成到您的网站或应用中。详细的技术文档可在开发者中心查看。',
  },
];